import { GET_CATEGORY_NAVIGATION } from '@dustin-web/microsite-data/src/graphql/product/category-navigation.graphql'
import { GetCategoryNavigationQuery } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks'

export type UseCategoryNavigation = typeof useCategoryNavigation

export const useCategoryNavigation = (isActive: boolean) => {
  const { data, isValidating, error } = useGraphql<GetCategoryNavigationQuery>(
    GET_CATEGORY_NAVIGATION,
    {
      context: {
        skip: !isActive,
        useGet: true,
      },
    }
  )
  return {
    data,
    error,
    isValidating,
  }
}
